import AbsComponent from "./AbsComponent";

export default class charNotAllowed extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);

        this.node = $(this.templ());
        this.node.hide();
        $('.contents-wrap').append(this.node);

        const watch = this.watch(this.store.getState, 'isAllowed', this.isEqual);
        this.store.subscribe( watch( ()=>{
            this.node.toggle(!this.store.getState().isAllowed);
        } ) );

        this.node.toggle(!this.store.getState().isAllowed);
    }

    templ(){
        return `
        <div class="no-char">
            <span class="text">该玩家关闭角色信息展示，无法查询。</span>
        </div>`;

        // “해당 유저가 캐릭터 정보 전시를 닫아 정보를 조회할 수 없습니다”
        // “该玩家关闭角色信息展示，无法查询。“
    }


} // end of class